import ApiRequestManagerInstance from '../ApiRequestManager';
import DeviceConfig from '@devices/config';
import { store } from '../../store/store';

function unpairDeviceRequest() {
  const promise = new Promise<boolean>(async (resolve) => {
    try {
      const { user } = store.getState();
      if (!user.isAnonymous && DeviceConfig.info.uuid) {
        await ApiRequestManagerInstance.delete({
          endpoint: {
            url: 'apiUrl',
            section: 'device',
            subsection: 'unpair',
            params: '/' + DeviceConfig.info.uuid,
          },
        });
      }
      resolve(true);
    } catch (e) {
      console.error(e);
      resolve(false);
    }
  });

  return promise;
}

export default unpairDeviceRequest;
